import { ExternalLink } from "lucide-react";
import { toast } from "sonner";

const BOTS = [
  { id: "chatgpt", name: "ChatGPT", url: (q) => `https://chatgpt.com/?q=${encodeURIComponent(q)}` },
  { id: "claude", name: "Claude", url: (q) => `https://claude.ai/new?q=${encodeURIComponent(q)}` },
  { id: "gemini", name: "Gemini", url: () => "https://gemini.google.com/app", paste: true },
];

export const ChatbotHandoff = ({ text }) => {
  const open = async (b) => {
    if (b.paste) {
      await navigator.clipboard?.writeText(text).catch(() => {});
      toast.success("Polite request copied. Paste it into Gemini!");
    }
    window.open(b.url(text), "_blank", "noopener");
  };

  return (
    <div className="pp-handoff" data-testid="chatbot-handoff">
      <p className="pp-label">Or take your polite request to</p>
      <div className="flex flex-wrap gap-2">
        {BOTS.map((b) => (
          <button key={b.id} data-testid={`handoff-${b.id}-button`} className="pp-ghost" onClick={() => open(b)}>
            {b.name} <ExternalLink className="h-3.5 w-3.5" />
          </button>
        ))}
      </div>
    </div>
  );
};
